import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import css from './TicketCount.module.scss';

interface Props {
  className?: string;
  count: number;
}

const TicketCount = (props: Props & InjectedIntlProps) => {
  return (
    <span className={classNames(css.TicketCount, props.className)}>
      <span className={css.TicketCount__Emphasis}>{props.count}</span>
      {props.intl.formatMessage({ id: 'merchants.common.ticketCount.unit' })}
    </span>
  );
};

export default injectIntl(TicketCount);
